import type { FaireProductEntity } from "../../entity_types/product";

export const p_4sj1piqs: FaireProductEntity = {
  token: "p_4sj1piqs",
  type: "product",
  name: "Nipple Crack™ Organic Nipple Balm 1.8oz",
  brandToken: "b_bfqoqeul",
  brandName: "Tiny Human Supply Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/a22c7318e869295b90fe5275a8049e5055bd0e351b77f3b54d9364d67b33cac1.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/74c9068067922d2ecb6d5c6ad6c49e5ac79375a90bb5f76215b233a0df3fe835.jpeg",
    "https://cdn.faire.com/fastly/c687b1e6ffea985f5d20e8ca7d07b603d841cb7763fd69b13b4021824e84e23c.jpeg",
    "https://cdn.faire.com/fastly/e359ba67c14a00febd3785c6795f5b654e69272beb6e7bd7db1b7a36d0ae1706.jpeg",
    "https://cdn.faire.com/fastly/2ad7c4f578b64f625cc97763d90fd582b995936a74770f6ba1282233843400c0.jpeg",
    "https://cdn.faire.com/fastly/f2c01750cf2a2c6baf68630f2a84146dc88aab8a88d3362a91e5586d2ffe6228.jpeg",
    "https://cdn.faire.com/fastly/602b73d1663a83c8e36d3a37c58e0c46c5c2b29e1403e0de929f7eae3de11827.png",
    "https://cdn.faire.com/fastly/1ad1df617fa293388463259ea696c56db8c69cc367dc32d7ea2227d5bdd24cfd.jpeg",
  ],
  priceDollars: 6.98,
  description:
    "CERTIFIED ORGANIC: Made with premium organic ingredients that are  odorless & tasteless -so you don’t have to wash it off before breastfeeding. \n\nSOOTHES ON CONTACT: Soothes and protects hardworking nipples on contact -fast relief when you need it the most. \n\nBUTTERY SOFT: Our lightweight formula spreads on easily and doesn’t leave a sticky or greasy residue -so it won’t stain your clothes or clog your pump. \n\nRECOMMENDED: Our nationwide network of Lactation Consultants, Doulas and breastfeeding professionals all highly recommend Nipple Crack Nipple Balm. \n\nMADE IN USA: Proudly made in the USA where strict quality and regulatory standards mean you can trust our premium products to be safe, effective and socially responsible. ",
  tags: [],
  msrpDollars: 13.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:12.549Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
